






















































import ItemCarousel from "@/general/components/organisms/ItemCarousel.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";

import { mapState, mapActions } from "vuex";
import { Prop, Vue, Component } from "vue-property-decorator";
import items from "@/general/store/modules/items";
import {
  browserHistory,
  getFavorites,
  getProductList
} from "@/general/store/api";
import ProductList from "../pages/ProductList.vue";

@Component({
  components: {
    ItemCarousel,
    ButtonMain
  }
})
export default class ItemCarouselGroup extends Vue {
  @Prop({ type: Array, required: true, default: false }) histories!: any;
  @Prop({ type: Array, required: true, default: false })
  recommendations!: any;
  @Prop({ type: Array, required: true, default: false }) favorites!: any;

  get showHistories() {
    return this.histories.length > 0;
  }

  get showRecommendations() {
    return this.recommendations.length > 0;
  }

  get showFavorites() {
    return this.favorites.length > 0;
  }
}
